module.exports = __webpack_public_path__ + "img/designguide_2.d11b254.jpg";